import { EditTagBskComponent } from './edit-tagbsk/edit-tagbsk.component';
import { AddTagBskComponent } from './add-tagbsk/add-tagbsk.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ListTagBskComponent } from './list-tagbsk/list-tagbsk.component';

export const routesTagBsk: Routes = [
    { path: 'page-tagbsk', component: ListTagBskComponent},
    { path: 'page-tagbsk/add', component: AddTagBskComponent},
    { path: 'page-tagbsk/:id/edit', component: EditTagBskComponent}
];

export const TagBskRoutes: ModuleWithProviders = RouterModule.forChild(routesTagBsk);
